import { render, staticRenderFns } from "./HomepageIcons.vue?vue&type=template&id=ad2a4c9c"
var script = {}
import style0 from "./HomepageIcons.vue?vue&type=style&index=0&id=ad2a4c9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports